<template>
	<div id="home">
		<div class="search-box">
			<div class="search">
				<input type="text" placeholder="搜索惠普资料网站" v-model="search">
				<button @click="getlist">搜索</button>
			</div>
		</div>
		<div class="type-list-box">
			<div class="type-box" :id="'box'+item.id" v-for="(item,index) in lists">
				<h2><img :src="item.icon_url||icon" alt="">{{item.title}}</h2>
				<p class="description">{{item.description}}</p>
				<div class="list-box">
					<a :href="item2.type==1?item2.mobile_url:'/pdfjs/web/viewer.html?file='+item2.file_url" v-for="(item2,index2) in item.lists">
						<div class="box" :style="'background: '+(item2.bg_color)+';'">
							<div class="top">
								<div class="logo"><img :src="item2.icon_url" alt=""></div>
								<p class="title">{{item2.title}}</p>
							</div>
							<p class="desciption">{{item2.description}}</p>
							<img src="@/assets/images/home-icon.png" alt="" class="icon">
						</div>
					</a>
				</div>
			</div>
		</div>
		<div class="footer"></div>
	</div>
</template>

<script>
import wxapi from "@/assets/js/wxsdk.js";
export default {
  mounted() {
	  this.getlist();
	  wxapi.wxRegister(this.wxRegCallback)
  },
  data() {
    return {
      navSelect: 0,
	  navList:[
		{name:"常用推荐"},
		{name:"综合资料"},
		{name:"耗材资料"},
		{name:"产品选型"},
		{name:"技术方案"},
		{name:"服务方案"},
		{name:"售后服务"},
	  ],
	  navFixed:false,
	  lists:[],
	  listsScrollTop:[],
	  search:"",
	  icon: require("@/assets/images/icon.png")
    }
  },
  components: {
	  
  },
  watch:{
	  wxRegCallback(){
		  wxapi.ShareTimeline({});
		  wxapi.ShareAppMessage({});
	  },
	  lists:function(){
		  this.$nextTick(function(){  
			var listsScrollTop=[];
			this.lists.forEach(function(item,index){
				listsScrollTop.push(document.getElementById("box"+item.id).offsetTop)
			})
			this.listsScrollTop=listsScrollTop
		  })
	  }
  },
  methods: {
	  getlist(txt){
		  this.fetchGet(`/api/v1/ent`,{search:this.search}).then((res) => {
			if(res.code==200){
				this.lists=res.data.data
			}
		  })
	  },
	  navChange(item){
		  document.documentElement.scrollTop=this.listsScrollTop[item]
	  },
	  scrolling(){
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
		let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
		let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
		if(scrollTop>129){
			this.navFixed=true
		}else{
			this.navFixed=false
		}
		let target = this.listsScrollTop;
		const output = target.find(item => item > scrollTop);
		var navSelect=target.indexOf(output)-1;
		if(navSelect<0){
			navSelect=0
		}
		this.navSelect=navSelect
	  }
  },
}
</script>
<style scoped>
	#home .search-box{margin-top: 0.22rem;padding: 0.32rem 0.26rem;background: #fff;overflow: hidden;box-sizing: border-box;}
	#home .search-box .logo{width: 0.67rem;height: 0.67rem;float: left;}
	#home .search-box .search{display: flex;}
	#home .search-box .search input{width: 100%;height: 0.6rem;border: 1px solid #000;vertical-align: top;padding: 0 0.22rem;border-right: 0;font-size: 0.24rem;}
	#home .search-box .search button{width: 1.28rem;flex: 0 0 auto;;height: 0.6rem;padding: 0;line-height: 0.6rem;text-align: center;font-size: 0.28rem;vertical-align: top;border: 1px solid #000;}
	#home .type-list-box{margin-bottom: 0.5rem;margin-top: 0.24rem;}
	#home .type-list-box .type-box{margin-bottom: 0.06rem;}
	#home .type-list-box h2{padding: 0 0.24rem;border-bottom: 1px solid #000;line-height: 0.6rem;font-size: 0.36rem;}
	#home .type-list-box h2 img{width: 0.33rem;height: 0.33rem;vertical-align: top;margin-right: 0.14rem;margin-top: 0.135rem;}
	#home .type-list-box .description{padding: 0 0.24rem;line-height: 0.42rem;font-size: 0.24rem;}
	#home .type-list-box .list-box{padding: 0 0.24rem;overflow: hidden;margin-top: 0.15rem;}
	#home .type-list-box .list-box a{margin-right: 0.18rem;margin-bottom: 0.18rem;display: block;float: left;}
	#home .type-list-box .list-box a:nth-of-type(2n){margin-right: 0;}
	#home .type-list-box .list-box .box{width: 3.4rem;height: 1.22rem;box-sizing: border-box;padding: 0.16rem 0.15rem;background: linear-gradient(90deg, rgba(0,150,214,0.96), rgba(130,68,199,0.96));color: #000;position: relative;}
	#home .type-list-box .list-box .box .top{display: flex;}
	#home .type-list-box .list-box .box .top .logo{width: 0.26rem;height: 0.26rem;margin-right: 0.13rem;flex: 0 0 auto;background: #ffffff;border-radius: 0.04rem;padding: 2px;box-sizing: border-box;}
	#home .type-list-box .list-box .box .top .logo img{width: 100%;height: 100%;display: block;}
	#home .type-list-box .list-box .box .top .title{font-size: 0.26rem;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;line-height: 0.26rem;}
	#home .type-list-box .list-box .box .desciption{font-size: 0.18rem;line-height: 0.28rem;display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;margin-top: 0.14rem;padding-right: 0.35rem;}
	#home .type-list-box .list-box .box .icon{width: 0.25rem;height: 0.25rem;position: absolute;bottom: 0.1rem;right: 0.12rem;}
	#home .footer{height: 0.72rem;background: #2F2F2F;}
</style>